class ProductTileController {
  constructor ($state, ProductUtilsService, $log) {
    'ngInject'
    this.$state = $state
    this.$log = $log
    this.productUtilsService = ProductUtilsService
    this.selected = false
  }

  $onInit () {
    if (this.product.group) {
      this.shortGroup = []
      this.product.group.forEach((item) => {
        this.shortGroup.push({ref: item.ref, duration: item.duration})
      })
    }
  }

  get illustration () {
    return this.productUtilsService.getIllustration(this.product)
  }

  get banner () {
    return this.productUtilsService.getBanner(this.product)
  }

  get duration () {
    return this.productUtilsService.getDuration(this.product, this.selected)
  }

  get actualPrice () {
    return this.productUtilsService.getActualPrice(this.product)
  }

  get isPromotion () {
    return this.productUtilsService.isPromotion(this.product)
  }

  onUpdateDuration (item) {
    this.selected = true
    const group = this.product.group
    this.product = Object.assign({}, item)
    this.product.group = group
  }
}

export default ProductTileController



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/components/product-tile/product-tile.controller.js